module.exports = __webpack_public_path__ + "img/exam_jan_2025_yhyc7gaj.89937c65.jpg";